import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { HttpStatusCodes } from 'app/infrastructure/remote-data';
import { RequestUiDefinition, ReceiveUiDefinition, FailUiDefinition } from './action-types';
import { api } from './api';
import { uiDefinitionExpirationTime } from './constants';

export const actionCreators = {

  getUiDefinition: (caseTypeId: number, caseContextId: number): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      const responseCachingState = getState().responseCaching;

      const uiDefinition = responseCachingState && responseCachingState.uiDefinitions &&
        responseCachingState.uiDefinitions.find(ui => ui.id === caseTypeId && ui.caseContextId === caseContextId);

      if (uiDefinition && uiDefinition.definition && uiDefinition.timestamp) {

        const currentTimestamp = new Date().getTime();

        if (currentTimestamp < uiDefinition.timestamp + uiDefinitionExpirationTime) {
          return uiDefinition.definition;
        }
      }

      dispatch(new RequestUiDefinition(caseTypeId, caseContextId));

      try {

        const eTag = uiDefinition && !!uiDefinition.definition && uiDefinition.eTag;
        const uiDefinitionResponse = await api.uiDefinition(caseTypeId, caseContextId, eTag);

        const newUiDefinition = uiDefinitionResponse.status === HttpStatusCodes.NOT_MODIFIED
          ? uiDefinition && uiDefinition.definition
          : uiDefinitionResponse.json.data;

        const newETag = uiDefinitionResponse.status === HttpStatusCodes.NOT_MODIFIED
          ? uiDefinition && uiDefinition.eTag
          : uiDefinitionResponse.etag;

        dispatch(new ReceiveUiDefinition(caseTypeId, caseContextId, newUiDefinition, newETag));

        return newUiDefinition;

      } catch (err) {

        dispatch(new FailUiDefinition(caseTypeId, caseContextId));
        throw err;
      }
    }
};
